/* 動画の目次(ta-video-index)のシーク。2026-08-29 新設。
 *
 * なぜテーマ側に置くか: 記事本文の <script> は公開時のサニタイザで**必ず除去**される
 * (manga_upload.extract_and_strip_scripts が ld+json 以外を拒否する)。本文には
 * マークアップだけを置き、挙動はテーマが与える。
 *
 * 契約(記事本文が出す DOM):
 *   .ta-feature-video           … 動画1本の入れ物(中に <video>)
 *   .ta-video-index a[data-ta-video-start="秒"] … 目次リンク
 * リンクの href は「記事URL?t=秒」(JS 無効でも意味が壊れないように)。
 * ここではクリックを奪って**同一ページ内でシーク**する(ページ再読み込みを避ける)。
 *
 * ページを ?t=NN で開いた場合も、その位置から再生できるようにする。
 */
(function () {
  "use strict";
  var wraps = document.querySelectorAll(".ta-feature-video");
  if (!wraps.length) return;

  function seek(video, sec) {
    var n = Number(sec);
    if (!video || !Number.isFinite(n) || n < 0) return;
    function apply() {
      try { video.currentTime = n; } catch (e) { return; }
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* 自動再生拒否は無視(位置だけ移す) */ });
    }
    if (video.readyState > 0) apply();
    else video.addEventListener("loadedmetadata", apply, { once: true });
  }

  Array.prototype.forEach.call(wraps, function (wrap) {
    var video = wrap.querySelector("video");
    if (!video) return;
    /* 目次リンク: 同一ページ内シーク(href の ?t= は JS 無効時のフォールバック) */
    wrap.addEventListener("click", function (event) {
      var a = event.target.closest("[data-ta-video-start]");
      if (!a || !wrap.contains(a)) return;
      event.preventDefault();
      seek(video, a.getAttribute("data-ta-video-start"));
      video.scrollIntoView({ block: "nearest" });
    });
  });

  /* ?t=NN で開かれたときは最初の動画をその位置へ(共有リンク・目次リンクの直開き) */
  try {
    var t = new URLSearchParams(location.search).get("t");
    if (t !== null) {
      var first = wraps[0].querySelector("video");
      if (first) seek(first, t);
    }
  } catch (e) { /* URLSearchParams が無い環境では何もしない */ }
})();

/* 「続きを読む」(details.tr-readmore)を開いた/閉じたときの表示URL。2026-08-29 追加。
 *
 * 目的: 無限スクロール(?n=&e=)・まんが拡大表示(?img=N)と同じ「表示URLだけ変える」施策。
 * GA4 の拡張計測は History 変更を page_view として数えるため、本文を開いた読者を
 * 計測できる(=読了意向のシグナル)。
 *
 * SEO/AIO 上の安全性(既存2施策と同じ契約):
 *   ・**replaceState のみ**(pushState にしない)。履歴を増やさないので戻るボタンが壊れない
 *   ・canonical は常にクリーンURL(テーマが出力。クエリを含めない)
 *   ・Shopify は未知クエリを無視して同じ本文を返す(=内容は完全同一)
 *   ・本文は開閉に関わらず**最初から DOM に全文ある**(details は表示制御のみ)。
 *     クローラは JS を実行しなくても全文を読める = インデックス内容は変わらない
 *   ・閉じたら パラメータを消す(初期状態のURLに痕跡を残さない)
 */
(function () {
  "use strict";
  var PARAM = "read";
  var d = document.querySelector("details.tr-readmore");
  if (!d) return;
  d.addEventListener("toggle", function () {
    try {
      var url = new URL(window.location.href);
      if (d.open) {
        if (url.searchParams.get(PARAM) === "1") return;
        url.searchParams.set(PARAM, "1");
      } else {
        if (!url.searchParams.has(PARAM)) return;
        url.searchParams.delete(PARAM);
      }
      history.replaceState(history.state, "", url);
    } catch (e) { /* URL API が無い環境では何もしない */ }
  });
  /* ?read=1 で開かれた場合は最初から開いておく(共有リンク・戻り遷移) */
  try {
    if (new URLSearchParams(location.search).get(PARAM) === "1") d.open = true;
  } catch (e) { /* noop */ }
})();
